import React, { useEffect, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';

const AuthToast = ({ show, message, type = 'warning', onClose, autoClose = true }) => {
    const [visible, setVisible] = useState(show);

    useEffect(() => {
        setVisible(show);

        if (show && autoClose) {
            const timer = setTimeout(() => {
                setVisible(false);
                if (onClose) onClose();
            }, 5000); // Auto-close after 5 seconds

            return () => clearTimeout(timer);
        }
    }, [show, autoClose, onClose]);

    if (!visible) return null;

    const typeStyles = {
        warning: {
            bg: 'bg-yellow-50',
            border: 'border-yellow-400',
            text: 'text-yellow-800',
            icon: '⚠️'
        },
        error: {
            bg: 'bg-red-50',
            border: 'border-red-400',
            text: 'text-red-800',
            icon: '❌'
        },
        info: {
            bg: 'bg-blue-50',
            border: 'border-blue-400',
            text: 'text-blue-800',
            icon: 'ℹ️'
        },
        success: {
            bg: 'bg-green-50',
            border: 'border-green-400',
            text: 'text-green-800',
            icon: '✓'
        }
    };

    const style = typeStyles[type] || typeStyles.info;

    return (
        <div className="fixed top-4 right-4 z-50 animate-slide-in-right">
            <div className={`${style.bg} ${style.border} border-l-4 p-4 rounded shadow-lg max-w-md`}>
                <div className="flex">
                    <div className="flex-shrink-0">
                        <span className="text-xl">{style.icon}</span>
                    </div>
                    <div className="ml-3 flex-1">
                        <p className={`text-sm font-medium ${style.text}`}>
                            {message}
                        </p>
                    </div>
                    {onClose && (
                        <div className="ml-auto pl-3">
                            <div className="-mx-1.5 -my-1.5">
                                <button
                                    type="button"
                                    onClick={() => {
                                        setVisible(false);
                                        onClose();
                                    }}
                                    className={`inline-flex rounded-md p-1.5 ${style.text} hover:bg-opacity-20 focus:outline-none focus:ring-2 focus:ring-offset-2`}
                                >
                                    <span className="sr-only">Dismiss</span>
                                    <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AuthToast;
